import "./App.scss";

import { Redirect, Route, Switch } from "react-router";
import ConsumerIndex from "./Consumer/ConsumerIndex";
import LoginPage from "./Consumer/LoginPage/LoginPage";
import LoginPortal from "./Consumer/Portals/LoginPortal/LoginPortal";
import Registration from "./Consumer/Registration/Registration";
import Dashboard from "./Consumer/Dashboard/Dashboard";
import SignUpMainPage from "./Consumer/SignUpMainPage/SignUpMainPage";
import RegisterInstitute from "./Consumer/RegisterInstitute/RegisterInstitute";
import HelpPage from "./Consumer/HelpPage/HelpPage";
import ContactPage from "./Consumer/ContactPage/ContactPage";
import InstituteDashboard from "./Consumer/InstituteDashboard/InstituteDashboard";
import React from "react";
import ResetPassword from "./Consumer/ResetPassword/ResetPassword";
import ForgotPasswordSection from "./Consumer/ForgotPasswordSection/ForgotPasswordSection";
import TermsAndConditions from "./Consumer/TermsAndConditions/TermsAndConditions";
import AboutPage from "./Consumer/AboutPage/AboutPage";
import { MainContext } from "./Consumer/Dashboard/DashboardContext/Context";
import LogOutModal from "./Consumer/Common/LogOutModal/LogOutModal";
function App() {
  const context = React.useContext(MainContext);
  const { logOutModal, updateState } = context;
  return (
    <div className="App">
      {logOutModal ? (
        <LogOutModal closeIt={() => updateState("logOutModal", false)} />
      ) : (
        ""
      )}

      <Switch>
        <Route path="/user" component={Dashboard} />
        <Route path="/institute" component={InstituteDashboard} />
        <Route path="/help" component={HelpPage} />
        <Route path="/contact" component={ContactPage} />
        <Route path="/login" component={LoginPage} />
        <Route path="/sign-up" component={SignUpMainPage} />
        <Route
          path="/privacy-policy"
          render={() => <TermsAndConditions pp={true} />}
        />
        <Route path="/terms-and-condition" component={TermsAndConditions} />
        <Route path="/register" component={Registration} />
        <Route path="/about" component={AboutPage} />
        <Route path="/passwordReset" component={ForgotPasswordSection} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/register-institute" component={RegisterInstitute} />
        <Route path="/" component={ConsumerIndex} />
      </Switch>
    </div>
  );
}

export default App;
